module.exports = __webpack_public_path__ + "img/logo1.492a7f48.png";